import api from "api/api";
export const deleteCountryById = async (id) =>
  await api.delete(`/settings/country/${id}`);

export const getCountryById = async (id) =>
  await api.get(`/settings/country/${id}`);

export const getCountryList = async () => await api.get("/settings/country");

export const createCountry = async (data) =>
  await api.post("/settings/country", data);

export const updateCountryById = async (id, data) =>
  await api.put(`/settings/country/${id}`, data);
